module.exports = "dist/bdcc60855a99a74049df5ca2d95eaefb.ttf";